import "react";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/components/FieldDisplayRenderWrapper.tsx
function FieldDisplayRenderWrapper({ children, config }) {
	if (config.internal) return /* @__PURE__ */ jsx("div", { children });
	return /* @__PURE__ */ jsx(Fragment$1, { children });
}
//#endregion
export { FieldDisplayRenderWrapper };

//# sourceMappingURL=FieldDisplayRenderWrapper.js.map